export const WMSOmniScanContextKeys = {
    ITEM: 'item',
    SHIPMENT: 'shipment',
    CONTAINER: 'container',
    SHIPMENT_CAN_BE_PACKED: 'shipmentCanBePacked' // This one is only for item inside the packing
}